/* tslint:disable */
/* eslint-disable */
/**
 * Rapurc API-spec
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Usability enum
 * @export
 * @enum {string}
 */
export enum Usability {
    Excellent = 'EXCELLENT',
    Good = 'GOOD',
    Poor = 'POOR',
    NotValidated = 'NOT_VALIDATED'
}

export function UsabilityFromJSON(json: any): Usability {
    return UsabilityFromJSONTyped(json, false);
}

export function UsabilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Usability {
    return json as Usability;
}

export function UsabilityToJSON(value?: Usability | null): any {
    return value as any;
}

